import type { ToastItem } from '../hooks/useToast';

interface ToastStackProps {
  toasts: ToastItem[];
  onDismiss: (id: string) => void;
}

export function ToastStack({ toasts, onDismiss }: ToastStackProps) {
  if (toasts.length === 0) return null;
  return (
    <div className="toast-stack" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast--${t.type || 'info'}`}>
          <span>{t.message}</span>
          {t.actionLabel && t.onAction && (
            <button
              type="button"
              className="toast-action"
              onClick={() => {
                onDismiss(t.id);
                t.onAction?.();
              }}
            >
              {t.actionLabel}
            </button>
          )}
          <button type="button" className="toast-close" onClick={() => onDismiss(t.id)} aria-label="关闭">
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
